export default __webpack_public_path__ + "static/media/(8).d58a3a38.jpeg";